module.exports = {
          srcSet: __webpack_public_path__ + "public/fed9f427fcf8c51db11b977d02a3af5e-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/fed9f427fcf8c51db11b977d02a3af5e-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/fed9f427fcf8c51db11b977d02a3af5e-80.png",
          toString:function(){return __webpack_public_path__ + "public/fed9f427fcf8c51db11b977d02a3af5e-80.png"},
          
          width: 80,
          height: 80
        }